<div class="titrations-plan-view">
    <div class="recommendation-button">
        <div class="recom-button" (click)="openTitrationsPlanPopup()">           
            <div class="text">
                <div>Titrationsplan</div>
            </div>
        </div>
    </div>
</div>
